import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../../../constants";
import { getMethodsForTestId } from "../../../utils/getMethodsForTestId";
import { keyCode } from "../../../utils/keyCodes";
import { isFunc } from "../../../utils/type";
import styles from './Suggestion.css';
var cx = classNames.bind(styles);
export var Suggestion = function Suggestion(_ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      _ref$highlighted = _ref.highlighted,
      highlighted = _ref$highlighted === void 0 ? false : _ref$highlighted,
      onClick = _ref.onClick,
      buttonProps = _ref.buttonProps,
      left = _ref.left,
      leftProps = _ref.leftProps,
      label = _ref.label,
      labelProps = _ref.labelProps,
      right = _ref.right,
      rightProps = _ref.rightProps,
      namespace = _ref.namespace;
  var ref = useRef(null);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'suggestion'),
      getTestId = _getMethodsForTestId.getTestId;

  var handleKeyDown = function handleKeyDown(e) {
    if (isFunc(onClick) && [keyCode.ENTER, keyCode.MAC_ENTER].includes(e.keyCode)) {
      onClick();
    }
  };

  useEffect(function () {
    if (highlighted) {
      var _ref$current;

      (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [highlighted]);
  return /*#__PURE__*/React.createElement("li", _extends({}, buttonProps, getTestId(), {
    ref: ref,
    role: "option",
    className: cx('root', {
      highlighted: highlighted
    }, classes.suggestion),
    onClick: onClick,
    onKeyDown: handleKeyDown,
    "aria-selected": highlighted ? true : undefined,
    tabIndex: highlighted ? 1 : -1
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('inner', classes.suggestionInner)
  }, left && /*#__PURE__*/React.createElement("span", _extends({}, leftProps, {
    className: cx('left', classes.suggestionLeft)
  }), left), /*#__PURE__*/React.createElement("span", _extends({}, labelProps, {
    className: cx('label', classes.suggestionLabel)
  }), label), right && /*#__PURE__*/React.createElement("span", _extends({}, rightProps, {
    className: cx('right', classes.suggestionRight)
  }), right)));
};